/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Approvals_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "When an agent stops to ask before it acts, the run waits here until someone decides." |
*
* @param {Agent_Approvals_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_approvals_empty_description = /** @type {((inputs?: Agent_Approvals_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Approvals_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn ein Agent vor einer Aktion nachfragt, wartet der Lauf hier, bis jemand entscheidet.")
	return /** @type {LocalizedString} */ ("When an agent stops to ask before it acts, the run waits here until someone decides.")
});